export enum AnnexedState {
  PENDING,
  OK,
  KO
}
